<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-double-left`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M25.902 35.355a1 1 0 000-1.403L16.105 24l9.797-9.952a1 1 0 000-1.403l-1.4-1.421a1 1 0 00-1.424 0L11.19 23.299a1 1 0 000 1.403l11.887 12.074a1 1 0 001.425 0l1.399-1.421zm9.907-1.403L26.012 24l9.797-9.952a1 1 0 000-1.403l-1.399-1.421a1 1 0 00-1.425 0L21.098 23.299a1 1 0 000 1.403l11.887 12.074a1 1 0 001.425 0l1.4-1.421a1 1 0 000-1.403z"/></svg>
</template>
<script>

export default {
  name: 'IconDoubleLeft',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
